import {
	checkCustomerExists,
	createCustomer,
	getLocation,
	goToPayment,
	createOrder,
} from "@/apiFunction.js";
import { mapGetters } from "vuex";
import errorToast from "@/mixins/toast";
export default {
	name: "Payment",
	mixins: [errorToast],
	data() {
		return {
			paymentButton: "",
			customerData: null,
			orderID: null,
		};
	},
	mounted() {
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		window.addEventListener("message", this.handleMessage);
		this.getPaymentFailure();
	},
	beforeDestroy() {
		window.removeEventListener("message", this.handleMessage);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
	},
	watch: {
		paymentButton(value) {
			if (value) {
				const button = this.$refs.responseContainer.querySelector("button");
				if (button) {
					button.click();
				}
			}
		},
	},
	created() {
		console.log(this.userDetails, "hellooo");
	},
	computed: {
		...mapGetters("sectionVUEX", {
			userDetails: "getUserDetails",
		}),
	},
	methods: {
		executeScriptTags() {
			const scripts = this.$refs.responseContainer.querySelectorAll("script");
			scripts.forEach((script) => {
				const scriptContent = script.textContent || script.innerText;
				const dynamicScript = document.createElement("script");
				dynamicScript.textContent = scriptContent;
				document.body.appendChild(dynamicScript);
				document.body.removeChild(dynamicScript);
			});
		},
		async paymentButtonShow(orderID) {
			try {
				const resp = await goToPayment(orderID);
				if (resp.status == 200) {
					this.$nextTick(() => {
						this.$refs.responseContainer.innerHTML = resp.data;
						this.paymentButton = resp.data;
						this.executeScriptTags();
					});
				} else {
					this.errorToast("Something went wrong !");
				}
			} catch (error) {
				console.log(error);
				this.errorToast("Something went wrong !");
			}
		},
		loadRazorpayLibrary(orderID) {
			const script = document.createElement("script");
			script.src = "https://checkout.razorpay.com/v1/checkout.js";
			script.onload = () => {
				this.paymentButtonShow(orderID);
			};
			document.head.appendChild(script);
		},
		getLocationDetails() {
			if ("geolocation" in navigator) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const latitude = position.coords.latitude;
						const longitude = position.coords.longitude;
						if (latitude && longitude) {
							this.getUserLocation(latitude, longitude);
						}
					},
					(error) => {
						this.Loaderstatus = false;
						this.errorToast("Please enable location permission to continue!");
						console.log(error);
					}
				);
			} else {
				console.log("Geolocation is not supported by this browser.");
				this.errorToast("Geolocation is not supported by this browser.");
			}
		},
		async checkCustomer() {
			console.log(this.userDetails);

			console.log(this.userDetails.email, "hjgfxcgvhbjn");

			try {
				const response = await checkCustomerExists(this.userDetails.email);

				if (response.status === 200) {
					this.customerData = response.data.data.customer;
					this.purchaseCourse();
				} else {
					// this.createNewCustomer("Bangalore, Karnataka");
					this.getLocationDetails();
				}
			} catch (error) {
				console.log(error);
				this.getLocationDetails();
			}
		},
		async getUserLocation(latitude, longitude) {
			try {
				console.log("came here ");

				let payload = {
					latitude: latitude.toString(),
					longitude: longitude.toString(),
				};
				const response = await getLocation(payload);
				if (response.status == 200) {
					this.createNewCustomer(response.data.data.formatted_address);
				} else {
					this.startDownload = false;
					this.Loaderstatus = false;
					this.errorToast("Something went wrong !");
				}
			} catch (error) {
				console.log(error, "error");
				this.errorToast("Something went wrong !");
			}
		},
		async createNewCustomer(address) {
			console.log("userdata", this.userData);

			try {
				let payload = {
					fullName: this.userDetails.firstName,
					customerAddress: address,
					email: this.userDetails.email,
					phoneNumber: null,
				};
				const response = await createCustomer(payload);
				if (response.status == 200) {
					this.customerData = response.data.data.customer;
					this.purchaseCourse();
				} else {
					this.errorToast("Something went wrong !");
				}
			} catch (error) {
				console.log(error);
				this.errorToast("Something went wrong !");
			}
		},
		async createOrder() {
			try {
				const payload = {
					customerID: this.customerData.customerID,
					email: this.userDetails.email,
					items: [{ itemID: this.paymentItemID, quantity: 1 }],
					currency: "INR",
					platform: "REC_CANDIDATE",
				};
				const response = await createOrder(payload);
				if (response.status === 201) {
					this.orderID = response.data.data.data.orderID;
					return response.data.data.data;
				} else {
					this.errorToast(response.data.data.data);
					return null;
				}
			} catch (error) {
				console.log(error);
				return null;
			}
		},
		async purchaseCourse() {
			console.log("purchase course");

			try {
				this.paymentProcessing = true;

				const { orderID } = await this.createOrder();
				this.orderID = orderID;
				if (orderID) {
					this.loadRazorpayLibrary(orderID);
				}
			} catch (error) {
				console.log(error);
			}
		},
		// async createTransaction(order_id, isFree = false) {
		// 	console.log("came to trans");

		// 	try {
		// 		const response = await createTransaction({
		// 			order_id,
		// 			isFree,
		// 			platform: "REC_CANDIDATE",
		// 		});
		// 		if (response.status === 201) {
		// 			this.postPurchaseTest(true);
		// 		} else {
		// 			this.errorToast("Something went wrong while creating transaction!");
		// 		}
		// 	} catch (error) {
		// 		console.log(error);
		// 	} finally {
		// 		this.paymentProcessing = false;
		// 	}
		// },
		handleBeforeUnload(event) {
			if (this.paymentProcessing) {
				event.preventDefault(); // This is necessary to display the alert message
			}
		},
		handleMessage(event) {
			if (event.data?.source === "hire3x-payment") {
				if (event.data.data.type == "Success") {
					this.paymentProcessing = false;
					this.postPurchaseTest(true);
				}
			}
		},
		getPaymentFailure() {
			const originalLog = console.log;
			console.log = (...args) => {
				// Call the original console.log method
				originalLog.apply(console, args);
				// Check if the logged message contains the data you're interested in
				const logMessage = args.join(" ");
				if (
					logMessage.includes("payment cancelled") &&
					this.paymentProcessing
				) {
					// this.errorToast("Payment cancelled!");
					this.paymentProcessing = false;
					this.enrollButtonLoader = false;
					this.Loaderstatus = false;
				}
			};
		},
	},
};
